<div class="alert d-flex align-items-center gap-3" [ngClass]="alertClass()">
  <i class="fa-solid fa-2x flex-shrink-0" [class]="iconClass()" aria-hidden="true"></i>
  <div>
    <div class="announcement-title fs-5">
      {{ announcementItem()?.title }}
    </div>
    <div class="announcement-body fs-6">
      {{ announcementItem()?.message }}
    </div>
  </div>
</div>